import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;

  padding: 10px;
  margin-top: 20px;
  margin-right: 20px;

  border-radius: 4px;

  background-color: var(--background-alt);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,
    rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
`;

export const Header = styled.div`
  cursor: pointer;

  width: 100%;

  display: flex;
  align-items: center;

  font-size: 24px;
  font-weight: bold;

  color: var(--primary);

  transition: all 75ms ease-in-out;

  img {
    width: 40px;
    height: 40px;

    margin-right: 16px;

    border: 3px solid var(--primary);
    border-radius: 50%;

    transition: all 75ms ease-in-out;

    flex-shrink: none;
    object-fit: cover;
  }

  &:hover {
    color: var(--hover-primary);

    text-decoration: underline;

    img {
      border: 3px solid var(--hover-primary);
      border-radius: var(--br-sm);
    }
  }
`;

export const ListMenu = styled.div`
  margin-top: 12px;

  display: flex;
  align-items: center;

  color: var(--secondary);

  font-weight: bold;
  text-transform: uppercase;

  cursor: pointer;

  svg {
    margin-right: 7px;
  }
`;
